// extracted by mini-css-extract-plugin
module.exports = {"loginForm":"loginForm_loginForm__UaZbn","errorMessage":"loginForm_errorMessage__w1pGT","formGroup":"loginForm_formGroup__Ppxd7","error":"loginForm_error__jKCpN"};